// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricA":"A_SaveElectricA__0ATnz"};